"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateReadableId = generateReadableId;
exports.generateReadableConditionModeId = generateReadableConditionModeId;
exports.generateSimplifiedIdsMap = generateSimplifiedIdsMap;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function generateReadableId(objectType, name, numRandomSuffixDigits = 4) {
    const encodedName = name.toLowerCase().replace(/[^a-zA-Z0-9]/g, (match) => '_' + match.charCodeAt(0).toString(36));
    const randomSuffix = numRandomSuffixDigits > 0 ? sigma_engine_shared_1.Utils.randomAlphaStr(numRandomSuffixDigits) : '';
    return `${objectType}_${encodedName}${encodedName.length > 0 && numRandomSuffixDigits > 0 ? '__' : ''}${randomSuffix}`;
}
function formatValueForId(value) {
    const absValue = Math.abs(value);
    const formattedValue = (Number.isInteger(absValue) ? absValue.toFixed(1) : absValue.toString()).replace('.', 'p');
    return value < 0 ? `n${formattedValue}` : formattedValue;
}
function generateReadableConditionModeId(signalName, minValue, nominalValue, maxValue) {
    const normalizedSignalName = signalName.toLowerCase();
    const normalizedMin = minValue !== null ? formatValueForId(minValue) : null;
    const normalizedNominal = nominalValue !== null ? formatValueForId(nominalValue) : null;
    const normalizedMax = maxValue !== null ? formatValueForId(maxValue) : null;
    if (normalizedMin !== null && normalizedMax !== null) {
        return `${normalizedSignalName}_${normalizedMin}_${normalizedMax}`;
    }
    else if (normalizedMin !== null) {
        return `${normalizedSignalName}_above_${normalizedMin}`;
    }
    else if (normalizedMax !== null) {
        return `${normalizedSignalName}_below_${normalizedMax}`;
    }
    else if (normalizedNominal !== null) {
        return `${normalizedSignalName}_${normalizedNominal}`;
    }
    else {
        throw new Error('At least one of minValue, nominalValue, or maxValue must be provided');
    }
}
function generateSimplifiedIdsMap(originalIdsWithNames, objectType) {
    const seenBaseIds = new Map();
    return Object.fromEntries(originalIdsWithNames.map(({ id, name }) => {
        const baseId = generateReadableId(objectType, name, 0);
        const count = seenBaseIds.get(baseId) ?? 0;
        const newId = count === 0 ? baseId : `${baseId}__${count}`;
        seenBaseIds.set(baseId, count + 1);
        return [id, newId];
    }));
}
//# sourceMappingURL=generate-readable-id.js.map